var _defs, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGkw9x5bVJ",
    x1: "55.633%",
    x2: "83.228%",
    y1: "56.385%",
    y2: "96.08%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGE3ljGbCT",
    x1: "50%",
    x2: "49.953%",
    y1: "0%",
    y2: "73.438%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("circle", {
    id: "SVGMFHNZdYm",
    cx: 128,
    cy: 128,
    r: 128
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "SVGalfYF1HT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#SVGMFHNZdYm"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#SVGalfYF1HT)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 128
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGkw9x5bVJ)",
    d: "M212.634 224.028L98.335 76.8H76.8v102.357h17.228V98.68L199.11 234.446a128 128 0 0 0 13.524-10.418"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGE3ljGbCT)",
    d: "M163.556 76.8h17.067v102.4h-17.067z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextjs);
export default __webpack_public_path__ + "static/media/nextjs.b0995b72f814e85f4a86245589fcb94b.svg";
export { ForwardRef as ReactComponent };